import axiosInstance from "../api";
import {
  GET_ACTIVE_JOB,
  GET_APPLIED_JOB,
  GET_COMPLETE_JOB,
  GET_JOB,
  GET_JOB_BY_ID,
  GET_MYOREDR_JOB,
} from "../constants";
import { getPostsById } from "../posts/action";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";

export const getJobList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post?type=${type}&is_mine=1`);
    if (response?.data?.status) {
      dispatch({ type: GET_JOB, getjoblist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getMyOrderJobList =
  (type, pagenumber, size, status) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `post?type=${type}&is_mine=1&index=${pagenumber}&size=${size}&status=${status}`,
      );
      if (response?.data?.status) {
        dispatch({ type: GET_MYOREDR_JOB, myorderjoblist: response?.data });
        return;
      }
      urtoast(response?.data?.response?.message, 2);
    } catch (err) {
      //urtoast(err.message, 2);
    }
  };

export const getJobAppliedList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `post?type=${type}&proposed=1&size=10`,
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_APPLIED_JOB,
        getjobappliedlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getJobActiveList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post?type=${type}&status=22`);
    if (response?.data?.status) {
      dispatch({
        type: GET_ACTIVE_JOB,
        getjobactivelist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getJobCompleteList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post?type=${type}&status=23`);
    if (response?.data?.status) {
      dispatch({
        type: GET_COMPLETE_JOB,
        getjobcompletelist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const addProject = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("post", data);
    if (response?.data?.status) {
      setLoading(false);
      urtoast(response?.data?.response?.message, 1);
      // window.location.reload()
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const ApplyForJob = (data, setLoading, navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("proposal/create", data);
    if (response?.data?.status) {
      setLoading(false);
      urtoast(response?.data?.response?.message, 1);
      navigate(data?.url, {
        state: { response: response?.data?.response, type: "job" },
      });
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const getProjectById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post/id?id=${id}`);
    if (response?.data?.status) {
      dispatch({ type: GET_JOB_BY_ID, getjobbyid: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const AcceptAllProposal =
  (data, setLoading, navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.put("proposal/update", data);
      if (response?.data?.status) {
        setLoading(false);
        navigate(data?.url, { state: { orderdetails: data?.state } });
        urtoast(response?.data?.response?.message, 1);
        return;
      }
      console.error();
      urtoast(response?.data?.response?.message, 2);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error();
      //urtoast(err.message, 2);
    }
  };

export const DeclineContractProposal =
  (data, setLoading, hitthismethod) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.put("proposal/update", data);
      if (response?.data?.status) {
        setLoading(false);
        hitthismethod();
        urtoast(response?.data?.response?.message, 1);
        return;
      }
      urtoast(response?.data?.response?.message, 2);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      //urtoast(err.message, 2);
    }
  };

export const sendhireRequest = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("proposal/update", data);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const PostJobtime = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("jobtime/create", data);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getPostsById(data?.posts_id));
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const AproveJobtime = (data, setLoading, onExtra) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("jobtime/update", data);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getPostsById(data?.posts_id));
      urtoast(response?.data?.response?.message, 1);
      return;
    }

    if (response?.data?.response?.extra == 1) {
      setLoading(false);
      onExtra && onExtra(response?.data?.response);
      return;
    }

    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const CompletetheJob = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("proposal/update", data);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getPostsById(data?.posts_id));
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};
